module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', [_c('span', [_vm._v("Room Id:")]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.greenroom.id))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Your Peer Id:")]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.greenroom.peerId))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Active speaker:")]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.activeSpeaker))])]), _vm._v(" "), _c('div', {
    staticClass: "add-feed"
  }, [_c('div', {
    staticClass: "selection-row"
  }, [_c('label', [_vm._v("Webcam")]), _vm._v(" "), _c('select', {
    ref: "webcam"
  }, _vm._l((_vm.manager.webcams.models), function(webcam) {
    return _c('option', {
      domProps: {
        "value": webcam.deviceId
      }
    }, [_vm._v(_vm._s(webcam.label) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.addWebcam
    }
  }, [_vm._v("Add webcam")]), _vm._v(" "), _c('div', {
    staticClass: "selection-row"
  }, [_c('label', [_vm._v("Microphone")]), _vm._v(" "), _c('select', {
    ref: "mic"
  }, _vm._l((_vm.manager.microphones.models), function(mic) {
    return _c('option', {
      domProps: {
        "value": mic.deviceId
      }
    }, [_vm._v(_vm._s(mic.label) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.addMic
    }
  }, [_vm._v("Add microphone")])]), _vm._v(" "), _c('div', [_c('h2', [_vm._v("Active Media")]), _vm._v(" "), _vm._l((_vm.greenroom.media.models), function(media) {
    return _c('div', {
      staticClass: "list"
    }, [_c('Media', {
      attrs: {
        "media": media,
        "show": _vm.show
      }
    })], 1)
  }), _vm._v(" "), _c('h2', [_vm._v("Peers")]), _vm._v(" "), _vm._l((_vm.greenroom.peers.models), function(peer) {
    return _c('div', {
      staticClass: "list"
    }, [_c('li', [_c('h3', [_vm._v(_vm._s(peer.id))]), _vm._v(" "), _c('div', [_vm._v("displayName: " + _vm._s(peer.displayName))]), _vm._v(" "), _c('div', [_vm._v("isHost: " + _vm._s(peer.isHost))])]), _vm._v(" "), _c('h3', [_vm._v("Media")]), _vm._v(" "), _c('li', {
      staticClass: "list"
    }, [_c('div', [_c('h4', [_vm._v("Webcam")]), _vm._v(" "), (peer.webcam) ? _c('Media', {
      attrs: {
        "media": peer.webcam,
        "show": _vm.show
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('h4', [_vm._v("Microphone")]), _vm._v(" "), (peer.microphone) ? _c('Media', {
      attrs: {
        "media": peer.microphone,
        "show": _vm.show
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('h4', [_vm._v("Screen")]), _vm._v(" "), (peer.screen) ? _c('Media', {
      attrs: {
        "media": peer.screen,
        "show": _vm.show
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('h4', [_vm._v("Audio")]), _vm._v(" "), (peer.audio) ? _c('Media', {
      attrs: {
        "media": peer.audio,
        "show": _vm.show
      }
    }) : _vm._e()], 1)])])
  })], 2), _vm._v(" "), _c('video', {
    ref: "video",
    attrs: {
      "autoplay": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79db9434","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Room.vue
// module id = 717
// module chunks = 1